import {
    GET_USER_LOGIN_STATUS, GET_USER_LOGIN_STATUS_START, IDENTITY, IDENTITY_START, LOGIN, LOGIN_START, LOGOUT,
    SESSION_EXPIRED
} from "./LoginActions";
import * as Optional from "optional-js";

const INITIAL_STATE = {
    isLogin: false,
    fetching: true,
    loggingIn: false,
    signingUp: false,
    sendingEmail: false,
    restoringPass: false,
    email: '',
    error: '',
    justLoggedOut: true,
    sessionExpired: false,
};

export default (state = INITIAL_STATE, action) => {
    switch(action.type) {
        case LOGIN_START:
            return {...state, loggingIn: true, error: ''};
        case LOGIN:
            if (action.error) {
                const error = Optional.of(action)
                    .map(action => action.payload)
                    .map(payload => payload.response)
                    .map(response => response.data)
                    .map(data => data.custom_message)
                    .orElse('Something went wrong. Please try again later.');
                // noinspection JSUnresolvedVariable
                const domainIsNotWhitelisted = error === "Current domain is not available for login";

                return {
                    ...state,
                    isLogin: false,
                    loggingIn: false,
                    error,
                    domainIsNotWhitelisted
                }
            }
            return {
                ...state,
                loggingIn: false,
                isLogin: true,
                loginSuccess: true,
                sessionExpired: false,
                loginMessage: "Signup",
                userName: action.payload.userName,
                domainIsNotWhitelisted: false
            };
        case IDENTITY_START:
            return {...state, fetching: true, justLoggedOut: false};
        case IDENTITY:
            if (action.error) {
                return {...state, fetching: false, isLogin: false, justLoggedOut: false};
            }
            return {
                ...state,
                fetching: false,
                isLogin: true,
                ...action.payload.data
            };
        case LOGOUT:
            if (action.error) {
                return {...state, fetching: false, error: action.error, justLoggedOut: true};
            }
            return {...state, fetching: false, isLogin: false, userName: ''};
        case GET_USER_LOGIN_STATUS_START:
            return {...state, fetching: true};
        case GET_USER_LOGIN_STATUS:
            if(action.error) {
                return {...INITIAL_STATE, fetching: false}
            }
            return {...state, ...action.payload.data, isLogin: true, fetching: false};
        case SESSION_EXPIRED:
            if(state.sessionExpired){
                return state;
            }
            return {...state, fetching: false, isLogin: false, justLoggedOut: true, sessionExpired: true};
    }
    return state;
};



// WEBPACK FOOTER //
// ./src/containers/login/LoginReducer.js